import { useGetEsitoQuery } from "../store/services/LookUpService"

export default function EsitoLookUp() {
    const {data} = useGetEsitoQuery('');

    const replaceEsito = (esito: string) => {
        let split =  esito.split(/(?=[A-Z])/);
        return `${split[0]} ${split[1] ? split[1]?.toLowerCase() : ''}`
    }

    let optionEsito = data?.map((esito: string) => ({value: esito, label: replaceEsito(esito)}))
    return optionEsito;
}